<template>
  <div class="customer">
    <div class="row">
      <form class="col-12" @submit.prevent="handleSubmit" v-if="customer">
        <div class="row">
          <div class="col-6">
            <h2>Billing Detail</h2>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <h3>Customer Name &amp; Account Details</h3>
          </div>
        </div>
        <div class="row">
          <div class="col-2">
            <label for="name">Name:</label>
          </div>
          <div class="col-9">
            <input
              type="text"
              class="form-control"
              id="name"
              name="name"
              ref="customer_name"
              placeholder="name"
              :value="getName()"
            />
          </div>
          <div
            v-if="submitted && errors.has('name')"
            class="col-12 invalid-feedback"
          >
            {{ errors.first("name") }}
          </div>
        </div>
        <div class="row">
          <div class="col-2">
            <label for="account">Account #:</label>
          </div>
          <div class="col-4">
            <input
              type="text"
              class="form-control"
              id="account"
              name="account"
              ref="customer_account"
              placeholder="account"
              :value="getAccount()"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <h3>Billing Address</h3>
          </div>
        </div>
        <div class="row">
          <div class="col-2">
            <label for="address1">Address 1:</label>
          </div>
          <div class="col-6">
            <input
              type="text"
              class="form-control"
              id="address1"
              ref="customer_address1"
              name="address1"
              placeholder=""
              :value="getAddressLine1()"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-2">
            <label for="address2">Address 2:</label>
          </div>
          <div class="col-6">
            <input
              type="text"
              class="form-control"
              id="address2"
              ref="customer_address2"
              name="address2"
              placeholder=""
              :value="getAddressLine2()"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-2">
            <label for="address3">Address 3:</label>
          </div>
          <div class="col-6">
            <input
              type="text"
              class="form-control"
              id="address3"
              ref="customer_address3"
              name="address3"
              placeholder=""
              :value="getAddressLine3()"
            />
          </div>
        </div>
        <div class="row">
          <div class=" col-2">
            <label for="city">City:</label>
          </div>
          <div class="col-4">
            <input
              type="text"
              class="form-control"
              id="city"
              ref="customer_city"
              name="city"
              placeholder="city"
              :value="getAddressCity()"
            />
          </div>
          <div class=" col-1">
            <label for="state">State:</label>
          </div>
          <div class="col-1 no-padding">
            <input
              type="text"
              class="form-control"
              id="state"
              ref="customer_state"
              name="state"
              placeholder="state"
              :value="getAddressState()"
            />
          </div>
          <div class=" col-2">
            <label for="postcode">Postcode:</label>
          </div>
          <div class="col-1 no-padding">
            <input
              type="text"
              class="form-control"
              id="postcode"
              ref="customer_postcode"
              name="postcode"
              placeholder="0000"
              :value="getAddressPostcode()"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <h3>Contact Details</h3>
          </div>
        </div>
        <div class="row">
          <div class=" col-2">
            <label for="phone">Phone:</label>
          </div>
          <div class="col-3">
            <input
              type="text"
              class="form-control"
              id="phone"
              ref="customer_phone"
              name="phone"
              placeholder="phone"
              :value="getContactPhone()"
            />
          </div>
          <div class=" col-2">
            <label for="fax">Fax:</label>
          </div>
          <div class="col-3">
            <input
              type="text"
              class="form-control"
              id="fax"
              ref="customer_fax"
              name="fax"
              placeholder="fax"
              :value="getContactFax()"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-2">
            <label for="email">Email:</label>
          </div>
          <div class="col-9">
            <input
              type="text"
              class="form-control"
              id="email"
              ref="customer_email"
              name="email"
              placeholder="email"
              :value="getContactEmail()"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-2">
            <label for="contact">Contact:</label>
          </div>
          <div class="col-9">
            <input
              type="text"
              class="form-control"
              id="contact"
              ref="customer_contact"
              name="contact"
              placeholder="contact"
              :value="getContactName()"
            />
          </div>
        </div>
      </form>
    </div>
    <div class="row">
      <div class="col-10">
        <button id="new" @click="$emit('new')" class="btn btn-plt">
          New
        </button>
        <button v-if="customer" id="save" @click="save" class="btn btn-plt">
          Save
        </button>
      </div>
      <div class="col-2" v-if="customer">
        <button
          id="delete"
          v-if="customer.active"
          @click="_delete"
          class="btn btn-danger"
        >
          Delete
        </button>
        <button id="delete" v-else @click="_delete" class="btn btn-primary">
          Reactivate
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";

export default {
  name: "CustomerDetail",
  props: {
    customer: {
      type: Object,
      default: null,
    },
  },
  data: () => ({
    submitted: false,
    customer_data: null,
  }),
  computed: {
    ...mapState("account", ["status"]),
  },
  mounted: function() {
    this.$nextTick(function() {
      if (this.customer == null) {
        this.new_customer();
      } else {
        this.customer_data = this.customer;
      }
    });
  },
  watch: {
    customer(new_value) {
      if (new_value != null) {
        this.customer_data = this.customer;
      }
    },
  },
  methods: {
    ...mapActions("customers", ["apiSaveCustomer", "apiCreateCustomer"]),
    // eslint-disable-next-line no-unused-vars
    handleSubmit(e) {
      this.submitted = true;
      this.$validator.validate().then(valid => {
        if (valid) {
          //save
        }
      });
    },
    new_customer() {
      this.customer_data = {
        active: true,
        address: { id: 0, active: true },
        address_id: 0,
        exported: false,
        jobs: [],
        sites: [],
        id: 0,
      };
    },
    save() {
      if (this.customer_data) {
        this.customer_data.name = this.$refs.customer_name.value;
        this.customer_data.account_number = this.$refs.customer_account.value;
        this.customer_data.phone = this.$refs.customer_phone.value;
        this.customer_data.fax = this.$refs.customer_fax.value;
        this.customer_data.email = this.$refs.customer_email.value;
        this.customer_data.contact = this.$refs.customer_contact.value;
        if (!this.customer_data.address) {
          this.customer_data.address = {
            active: true,
            id: 0,
          };
        }
        this.customer_data.address.address1 = this.$refs.customer_address1.value;
        this.customer_data.address.address2 = this.$refs.customer_address2.value;
        this.customer_data.address.address3 = this.$refs.customer_address3.value;
        this.customer_data.address.city = this.$refs.customer_city.value;
        this.customer_data.address.state = this.$refs.customer_state.value;
        this.customer_data.address.postcode = this.$refs.customer_postcode.value;
        if (this.customer_data.id > 0) {
          this.apiSaveCustomer(this.customer_data);
        } else {
          this.apiCreateCustomer(this.customer_data);
        }
        this.$emit("saved");
      }
    },
    getName() {
      if (!this.customer) {
        return "";
      }
      return this.customer.name;
    },
    getAccount() {
      if (!this.customer) {
        return "";
      }
      return this.customer.account_number;
    },
    getAddressLine1() {
      if (!this.customer || !this.customer.address) {
        return "";
      }
      return this.customer.address.address1;
    },
    getAddressLine2() {
      if (!this.customer || !this.customer.address) {
        return "";
      }
      return this.customer.address.address2;
    },
    getAddressLine3() {
      if (!this.customer || !this.customer.address) {
        return "";
      }
      return this.customer.address.address3;
    },
    getAddressCity() {
      if (!this.customer || !this.customer.address) {
        return "";
      }
      return this.customer.address.city;
    },
    getAddressState() {
      if (!this.customer || !this.customer.address) {
        return "";
      }
      return this.customer.address.state;
    },
    getAddressPostcode() {
      if (!this.customer || !this.customer.address) {
        return "";
      }
      return this.customer.address.postcode;
    },
    getContactPhone() {
      if (!this.customer) {
        return "";
      }
      return this.customer.phone;
    },
    getContactFax() {
      if (!this.customer) {
        return "";
      }
      return this.customer.fax;
    },
    getContactEmail() {
      if (!this.customer) {
        return "";
      }
      return this.customer.email;
    },
    getContactName() {
      if (!this.customer) {
        return "";
      }
      return this.customer.contact;
    },
    _delete() {
      if (this.customer_data && this.customer_data.id > 0) {
        this.customer_data.active = !this.customer_data.active;
        this.apiSaveCustomer(this.customer_data);
      }
    },
  },
  components: {},
};
</script>
